import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UserNameCommunication {
  private userNameSubject = new BehaviorSubject('');

  userName = this.userNameSubject.asObservable();

  updateUserName(userName: string): void {
    this.userNameSubject.next(userName);
  }
}
